define('modules/lp_integration/collections/form_fields',['require','exports','module','backbone','lib/util'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
    util = require("lib/util");

  var FormFields = Backbone.Collection.extend({
    _findStep: function(num) {
      return this.find(function(formStep){
        return formStep.get("step") === num;
      });
    },
    getFieldsForStep: function(num) {
      var formStep = this._findStep(num);
      return formStep? formStep.get("fields") : [];
    },
    setFieldsForStep: function(num, fields) {
      var formStep = this._findStep(num);
      if (!formStep) {
        formStep = this.add(new Backbone.Model({step: num, fields: []}));
      }
      formStep.set("fields", _.reduce(fields, function(all, field) {
        var currentNameAttrCandidate = field.nameAttr || field.labelText || field,
          nameAttr = util.sanitizeString(currentNameAttrCandidate);

        if (field.name != "custom:fblogin" && !_.contains(all, nameAttr)) {
          all.push(nameAttr);
        }
        return all;
      }, []));
    }
  });

  module.exports = FormFields;
});

